module.exports = __webpack_public_path__ + "img/62976785-5932-47f8-9e2b-bfdb09246bad.b9d7f015.jpg";